import type { Product } from '../pages/products/components/ProductCard';

export const products: Product[] = [
  {
    id: 'mango',
    name: 'Freeze Dried Mango',
    category: 'Fruits',
    origin: 'Cebu, Philippines',
    process: 'Sublimation freeze-drying at -40°C for 24–36 hours',
    description: 'Sweet, golden Philippine mangoes freeze-dried at peak ripeness to lock in natural flavor and nutrients. Perfect for snacking, baking, and smoothie mixes.',
    image: 'https://public.readdy.ai/ai/img_res/e2bed17e7381eef897849e68e38587ed.jpg',
    tags: ['Vegan', 'Gluten-Free', 'No Preservatives', 'Non-GMO'],
    nutrition: {
      servingSize: '30g (approx. 1 oz)',
      calories: 96,
      protein: '1.2g',
      carbs: '24.8g',
      fiber: '2.6g',
      sugar: '22.1g',
      fat: '0.4g',
      sodium: '3mg',
      vitaminC: '45mg (50% DV)',
      potassium: '210mg (6% DV)',
    },
    packaging: [
      { size: '50g', type: 'Resealable Pouch', shelfLife: '18 months', price: '₱120' },
      { size: '250g', type: 'Stand-up Bag', shelfLife: '18 months', price: '₱480' },
      { size: '1kg', type: 'Vacuum Sealed Bag', shelfLife: '24 months', price: '₱1,650' },
      { size: '5kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱7,500' },
      { size: '10kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱13,500' },
    ],
  },
  {
    id: 'strawberry',
    name: 'Freeze Dried Strawberry',
    category: 'Fruits',
    origin: 'Benguet, Philippines',
    process: 'Sublimation freeze-drying at -40°C for 20–28 hours',
    description: 'Vibrant red strawberries from the cool highlands of Benguet, freeze-dried to preserve their bright color, tangy sweetness, and high vitamin C content.',
    image: 'https://readdy.ai/api/search-image?query=bright%20red%20freeze%20dried%20strawberry%20slices%20and%20whole%20pieces%20arranged%20on%20clean%20white%20marble%20surface%20with%20soft%20studio%20lighting%20showing%20crispy%20airy%20texture%20professional%20food%20photography%20minimal%20background&width=600&height=400&seq=spec002&orientation=landscape',
    tags: ['Vegan', 'Gluten-Free', 'High Vitamin C', 'Non-GMO'],
    nutrition: {
      servingSize: '30g (approx. 1 oz)',
      calories: 88,
      protein: '1.8g',
      carbs: '21.2g',
      fiber: '3.8g',
      sugar: '16.4g',
      fat: '0.8g',
      sodium: '2mg',
      vitaminC: '210mg (233% DV)',
      potassium: '280mg (8% DV)',
      iron: '1.2mg (7% DV)',
    },
    packaging: [
      { size: '50g', type: 'Resealable Pouch', shelfLife: '18 months', price: '₱135' },
      { size: '250g', type: 'Stand-up Bag', shelfLife: '18 months', price: '₱520' },
      { size: '1kg', type: 'Vacuum Sealed Bag', shelfLife: '24 months', price: '₱1,800' },
      { size: '5kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱8,200' },
      { size: '10kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱15,000' },
    ],
  },
  {
    id: 'pineapple',
    name: 'Freeze Dried Pineapple',
    category: 'Fruits',
    origin: 'Bukidnon, Philippines',
    process: 'Sublimation freeze-drying at -40°C for 28–36 hours',
    description: 'Juicy Bukidnon pineapple rings and chunks freeze-dried to deliver a tropical burst of flavor. Ideal for trail mixes, cereals, and confectionery.',
    image: 'https://readdy.ai/api/search-image?query=golden%20yellow%20freeze%20dried%20pineapple%20rings%20and%20chunks%20on%20clean%20white%20background%20with%20soft%20natural%20lighting%20showing%20light%20crispy%20texture%20tropical%20fruit%20professional%20food%20photography%20minimal%20backdrop&width=600&height=400&seq=spec003&orientation=landscape',
    tags: ['Vegan', 'Gluten-Free', 'Tropical', 'Non-GMO'],
    nutrition: {
      servingSize: '30g (approx. 1 oz)',
      calories: 102,
      protein: '0.8g',
      carbs: '26.4g',
      fiber: '1.8g',
      sugar: '20.6g',
      fat: '0.2g',
      sodium: '1mg',
      vitaminC: '38mg (42% DV)',
      potassium: '195mg (6% DV)',
    },
    packaging: [
      { size: '50g', type: 'Resealable Pouch', shelfLife: '18 months', price: '₱110' },
      { size: '250g', type: 'Stand-up Bag', shelfLife: '18 months', price: '₱440' },
      { size: '1kg', type: 'Vacuum Sealed Bag', shelfLife: '24 months', price: '₱1,550' },
      { size: '5kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱7,000' },
      { size: '10kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱12,800' },
    ],
  },
  {
    id: 'banana',
    name: 'Freeze Dried Banana',
    category: 'Fruits',
    origin: 'Davao, Philippines',
    process: 'Sublimation freeze-drying at -40°C for 22–30 hours',
    description: 'Naturally sweet Davao bananas freeze-dried into light, crunchy slices. High in potassium and energy — a favorite for health-conscious consumers and athletes.',
    image: 'https://readdy.ai/api/search-image?query=pale%20yellow%20freeze%20dried%20banana%20slices%20arranged%20in%20neat%20rows%20on%20clean%20white%20surface%20with%20soft%20studio%20lighting%20showing%20crispy%20light%20texture%20professional%20food%20photography%20minimal%20background&width=600&height=400&seq=spec004&orientation=landscape',
    tags: ['Vegan', 'Gluten-Free', 'High Potassium', 'Energy Boost'],
    nutrition: {
      servingSize: '30g (approx. 1 oz)',
      calories: 107,
      protein: '1.3g',
      carbs: '27.5g',
      fiber: '3.1g',
      sugar: '14.8g',
      fat: '0.4g',
      sodium: '1mg',
      vitaminC: '10mg (11% DV)',
      potassium: '450mg (13% DV)',
      iron: '0.8mg (4% DV)',
    },
    packaging: [
      { size: '50g', type: 'Resealable Pouch', shelfLife: '18 months', price: '₱100' },
      { size: '250g', type: 'Stand-up Bag', shelfLife: '18 months', price: '₱400' },
      { size: '1kg', type: 'Vacuum Sealed Bag', shelfLife: '24 months', price: '₱1,450' },
      { size: '5kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱6,500' },
      { size: '10kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱11,800' },
    ],
  },
  {
    id: 'okra',
    name: 'Freeze Dried Okra',
    category: 'Vegetables',
    origin: 'Nueva Ecija, Philippines',
    process: 'Sublimation freeze-drying at -40°C for 18–24 hours',
    description: 'Tender green okra freeze-dried to preserve its natural crunch and high fiber content. Popular as a healthy snack and ingredient in soups and stews.',
    image: 'https://readdy.ai/api/search-image?query=bright%20green%20freeze%20dried%20okra%20pieces%20and%20slices%20arranged%20on%20clean%20white%20surface%20with%20soft%20natural%20lighting%20showing%20crispy%20texture%20and%20vibrant%20green%20color%20professional%20food%20photography%20minimal%20background&width=600&height=400&seq=spec005&orientation=landscape',
    tags: ['Vegan', 'Gluten-Free', 'High Fiber', 'Low Calorie'],
    nutrition: {
      servingSize: '30g (approx. 1 oz)',
      calories: 72,
      protein: '4.2g',
      carbs: '15.6g',
      fiber: '7.8g',
      sugar: '3.2g',
      fat: '0.6g',
      sodium: '18mg',
      vitaminC: '52mg (58% DV)',
      calcium: '180mg (18% DV)',
      iron: '1.8mg (10% DV)',
    },
    packaging: [
      { size: '50g', type: 'Resealable Pouch', shelfLife: '18 months', price: '₱95' },
      { size: '250g', type: 'Stand-up Bag', shelfLife: '18 months', price: '₱380' },
      { size: '1kg', type: 'Vacuum Sealed Bag', shelfLife: '24 months', price: '₱1,350' },
      { size: '5kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱6,200' },
      { size: '10kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱11,500' },
    ],
  },
  {
    id: 'carrot',
    name: 'Freeze Dried Carrot',
    category: 'Vegetables',
    origin: 'Benguet, Philippines',
    process: 'Sublimation freeze-drying at -40°C for 20–26 hours',
    description: 'Sweet highland carrots freeze-dried into vibrant orange pieces. Rich in beta-carotene and antioxidants, perfect for soups, baby food, and health mixes.',
    image: 'https://readdy.ai/api/search-image?query=bright%20orange%20freeze%20dried%20carrot%20slices%20and%20diced%20pieces%20arranged%20on%20clean%20white%20surface%20with%20soft%20studio%20lighting%20showing%20crispy%20texture%20and%20vivid%20orange%20color%20professional%20food%20photography%20minimal%20background&width=600&height=400&seq=spec006&orientation=landscape',
    tags: ['Vegan', 'Gluten-Free', 'Beta-Carotene', 'Non-GMO'],
    nutrition: {
      servingSize: '30g (approx. 1 oz)',
      calories: 78,
      protein: '1.8g',
      carbs: '18.4g',
      fiber: '5.2g',
      sugar: '9.1g',
      fat: '0.3g',
      sodium: '62mg',
      vitaminC: '18mg (20% DV)',
      potassium: '320mg (9% DV)',
      calcium: '90mg (9% DV)',
    },
    packaging: [
      { size: '50g', type: 'Resealable Pouch', shelfLife: '18 months', price: '₱90' },
      { size: '250g', type: 'Stand-up Bag', shelfLife: '18 months', price: '₱360' },
      { size: '1kg', type: 'Vacuum Sealed Bag', shelfLife: '24 months', price: '₱1,280' },
      { size: '5kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱5,800' },
      { size: '10kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱10,800' },
    ],
  },
  {
    id: 'bell-pepper',
    name: 'Freeze Dried Bell Pepper',
    category: 'Vegetables',
    origin: 'Bukidnon, Philippines',
    process: 'Sublimation freeze-drying at -40°C for 18–22 hours',
    description: 'Colorful red, yellow, and green bell peppers freeze-dried to retain their sweet flavor and exceptional vitamin C levels. Great for cooking and seasoning blends.',
    image: 'https://readdy.ai/api/search-image?query=colorful%20freeze%20dried%20bell%20pepper%20pieces%20in%20red%20yellow%20and%20green%20colors%20arranged%20on%20clean%20white%20surface%20with%20soft%20natural%20lighting%20showing%20crispy%20texture%20professional%20food%20photography%20minimal%20background&width=600&height=400&seq=spec007&orientation=landscape',
    tags: ['Vegan', 'Gluten-Free', 'High Vitamin C', 'Colorful Mix'],
    nutrition: {
      servingSize: '30g (approx. 1 oz)',
      calories: 68,
      protein: '2.4g',
      carbs: '15.8g',
      fiber: '4.6g',
      sugar: '8.4g',
      fat: '0.5g',
      sodium: '8mg',
      vitaminC: '285mg (317% DV)',
      potassium: '290mg (8% DV)',
      iron: '1.4mg (8% DV)',
    },
    packaging: [
      { size: '50g', type: 'Resealable Pouch', shelfLife: '18 months', price: '₱105' },
      { size: '250g', type: 'Stand-up Bag', shelfLife: '18 months', price: '₱420' },
      { size: '1kg', type: 'Vacuum Sealed Bag', shelfLife: '24 months', price: '₱1,500' },
      { size: '5kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱6,800' },
      { size: '10kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱12,500' },
    ],
  },
  {
    id: 'tropical-blend',
    name: 'Tropical Fruit Blend',
    category: 'Custom Blends',
    origin: 'Various Regions, Philippines',
    process: 'Individual sublimation freeze-drying then blended under controlled conditions',
    description: 'A premium mix of mango, pineapple, banana, and papaya — all freeze-dried separately and blended for a balanced tropical flavor profile. Ideal for retail snack packs.',
    image: 'https://readdy.ai/api/search-image?query=colorful%20assortment%20of%20mixed%20freeze%20dried%20tropical%20fruits%20mango%20pineapple%20banana%20papaya%20pieces%20arranged%20artistically%20on%20clean%20white%20surface%20with%20soft%20natural%20lighting%20professional%20food%20photography%20minimal%20background&width=600&height=400&seq=spec008&orientation=landscape',
    tags: ['Vegan', 'Gluten-Free', 'Mixed Fruits', 'Retail Ready'],
    nutrition: {
      servingSize: '30g (approx. 1 oz)',
      calories: 98,
      protein: '1.1g',
      carbs: '25.2g',
      fiber: '2.4g',
      sugar: '20.8g',
      fat: '0.4g',
      sodium: '2mg',
      vitaminC: '55mg (61% DV)',
      potassium: '240mg (7% DV)',
    },
    packaging: [
      { size: '100g', type: 'Resealable Pouch', shelfLife: '18 months', price: '₱220' },
      { size: '500g', type: 'Stand-up Bag', shelfLife: '18 months', price: '₱950' },
      { size: '1kg', type: 'Vacuum Sealed Bag', shelfLife: '24 months', price: '₱1,750' },
      { size: '5kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱7,800' },
      { size: '10kg', type: 'Bulk Sack', shelfLife: '24 months', price: '₱14,200' },
    ],
  },
];
